// Shorthand for $( document ).ready()
$(function() {

$("#custom_nav_mob a.nav__link.nav__link").click(function(e) {  
  $(this).find('svg').toggleClass('rotate');
  $(this).siblings(".nav__submenu").toggle();
  e.preventDefault();
});
   $('.slide_img_container').slick({
      slidesToShow: 1,
      centerMode: false,
      slidesToScroll: 1,
      cssEase: 'linear',
      autoplay: true,
      speed: 1000,
      autoplayspeed: 0,
      arrows: false,
      cssEase: 'linear',
      infinite: true,
      dots: true
  });
  
  $('.custom_thumbnail_slider').slick({
      slidesToShow: 3,
      centerMode: false,
      arrows: false,
      cssEase: 'linear',
      vertical: true,
      verticalScrolling: true,
      draggable: true,
      infinite: true,
      verticalSwiping: true,
      focusOnSelect: true,
      dots: true,
      responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          verticalSwiping: false,
          arrows: true,
          dots: false,
          vertical: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: true,
          dots: false,
          slidesToShow: 1,
          vertical: false,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });


  $(".color-swatch").click(function(){
        $(".swatch_val").text($(this).attr('data-option'));
  });


  $(".btn_tabs").click(function(){
    var data_val = $(this).text().toLowerCase().replace(/ /g,"_");

    $("#tabs_collections slider-component.slider-mobile-gutter.page-width-desktop ul").addClass("hide_collection");
    $("#tabs_collections slider-component.slider-mobile-gutter.page-width-desktop ul").removeClass("display_collection");
    $("#" + data_val).removeClass("hide_collection");
    $("#" + data_val).addClass("display_collection");
  });
  

});